import { render, staticRenderFns } from "./ResetCode.vue?vue&type=template&id=50695b12&scoped=true"
import script from "./ResetCode.vue?vue&type=script&lang=js"
export * from "./ResetCode.vue?vue&type=script&lang=js"
import style0 from "./ResetCode.vue?vue&type=style&index=0&id=50695b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50695b12",
  null
  
)

export default component.exports